'use strict';

var medium = require('../../node_modules/use-sidecar/dist/es2015/medium.cjs');

var effectCar = medium.createSidecarMedium();

exports.effectCar = effectCar;
//# sourceMappingURL=medium.cjs.map
